// extracted by mini-css-extract-plugin
module.exports = {"publications":"Publications_publications__1V7iY","moreButton":"Publications_moreButton__1LiNf"};